import { useEffect, useState } from "react";
import "./ScrollTopButton.scss";
import { BvIcon } from "bevi-icon";

export default function ScrollTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="ScrollTopButton" data-testid="ScrollTopButton">
      <button
        onClick={scrollToTop}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Voltar ao topo"
        className={`scroll-top-btn ${isVisible ? "visible" : ""}`}
      >
        <BvIcon name="arrowForward" color={isHovered ? "#ffffff" : "#222343"} />
      </button>
    </div>
  );
}
